import jwtDecode from 'jwt-decode';
import { Enums } from './enums.js';

class AuthToken{


    // PROPERTIES
    //-------------------------------------------------------------------------------------------------------------------
    _decodedToken = {};
    _savedToken = null;

    //==================================
    // Property: user
    //==================================
    get user(){

        if( Object.keys(this._decodedToken) == 0 && this.token !== null ){
            //this._decodedToken = jwtDecode(this.token); TODO
            let sessionToken = this.DeserializeAndParseJSNToken(this.token);

            //For some reason, the old token code swapped some of the property names on encoding.
            //Rather than try to find them all and change them, we'll just map them here.
            //Note that this mapping does not change the savedToken, which is what gets sent back to
            //the server for requests.  The decoded token would be incompatible with the session token
            //on the server after the mapping.
            this._decodedToken = this.MapDecodedSessionToken(sessionToken.JWTPayload);
        }
        return this._decodedToken;
    }
  
    //==================================
    // Property: token
    //==================================
    get token(){
        if( this._savedToken === null ){
            this._savedToken = sessionStorage.getItem("token");
        }
        return this._savedToken;
    }

    //==================================
    // ClearToken
    //==================================
    ClearToken(){
        sessionStorage.removeItem("token");
        this._savedToken = null;
        this._decodedToken = {}; //Got to do this or the back button will "partially work instead of getting redirected"
    }

    //==================================
    // GetUserInitials
    //==================================
    GetUserInitials(){
        if (this.user.lastname.toLowerCase() != "(debug)"){
            return this.user.firstname.substr(0,1).toUpperCase() + this.user.lastname.substr(0,1).toUpperCase()
        }

        return "DB"; //Debug User
    };

    //==================================
    // IsDataViewer
    //==================================
    IsDataViewer(){
        return this.user.role === Enums.Roles.DataViewer.id;
    };

    //==================================
    // IsLocal
    //==================================
    IsLocal(){
        return this.user.role === Enums.Roles.LocalDataSteward.id;
    };

    //==================================
    // IsNational
    //==================================
    IsNational(){
        return this.user.role != Enums.Roles.StateDataSteward.id;
        //var bIsNational = 
        //    this.user.role === Enums.Roles.NHQNationalPracticeDataSteward.id || 
        //    this.user.role === Enums.Roles.NHQNationalReportingDataSteward.id ||
        //    this.user.role === Enums.Roles.NationalDisciplineDataSteward.id ||
        //    this.user.role === Enums.Roles.NationalDisciplineDataSteward.id;
        //return bIsNational;
    };

    //==================================
    // IsState
    //==================================
    IsState(){
        return this.user.role === Enums.Roles.StateDataSteward.id;
    };

    //==================================
    // isUserLoggedIn
    //==================================
    isUserLoggedIn(){
        let loggedIn = (this.user && this.user.role && this.user.role > 0) ? true : false;
        return loggedIn;
    };


    // HELPER METHODS
    //-------------------------------------------------------------------------------------------------------------------
    //==================================
    // DeserializeAndParseJSNToken
    //==================================
    DeserializeAndParseJSNToken(token) {

        let keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;

        var input = token.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        while (i < input.length) {

            enc1 = keyStr.indexOf(input.charAt(i++));
            enc2 = keyStr.indexOf(input.charAt(i++));
            enc3 = keyStr.indexOf(input.charAt(i++));
            enc4 = keyStr.indexOf(input.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }

        return JSON.parse(output);
    }

    //==================================
    // MapDecodedSessionToken
    //==================================
    // Converts from the session token model to the client's decoded auth token model
    MapDecodedSessionToken(sessionToken) {

        return {
            username: sessionToken.firstName + " " + sessionToken.lastName,
            lastname: sessionToken.lastName,
            firstname: sessionToken.firstName,
            role: sessionToken.roleId,
            stateCode: sessionToken.stateCode,
            state: sessionToken.state,
            auth: sessionToken.eAuth,
            userId: sessionToken.userId,
            isEAuth: true,
            roleName: sessionToken.role,
            stateName: sessionToken.stateName,

            counties: [],
            countyNames: []
        };

    }
  
}

export const authToken = new AuthToken(); 

